import { createContext, useContext } from 'react'
import { VerificationSubject } from './subjects'

/**
 * Carries the component subject a showcase is being rendered for, so the
 * showcase's own `Section` card can put the verification badge in its header
 * without all 25 showcase files having to thread a prop through.
 *
 * The Components page provides the subject around each showcase; the first
 * `Section` rendered inside claims it and provides `null` to its own subtree, so
 * a showcase with several sections still shows exactly one badge. React renders
 * parents before children, so the claim always lands on the outermost card.
 */
export const ComponentSubjectContext = createContext<VerificationSubject | null>(null)

export function useComponentSubjectSlot(): VerificationSubject | null {
    return useContext(ComponentSubjectContext)
}
